import React, { useCallback, useState } from 'react';
import { createContext, useContext } from 'react';

const FOOTER_TYPE = {
  DETAILED: 'DETAILED',
  NORMAL: 'NORMAL',
} as const;
export type FooterType = typeof FOOTER_TYPE[keyof typeof FOOTER_TYPE];

type CustomizeFooterContextProps = {
  type: FooterType;
  setType: (type: FooterType) => () => void; // clean up functionも返している
};

const CustomizeFooterContext = createContext<CustomizeFooterContextProps>({
  type: FOOTER_TYPE.NORMAL,
  setType: () => () => {
    return;
  },
});

export const useFooterContext = (): CustomizeFooterContextProps => {
  const context = useContext(CustomizeFooterContext);

  return context;
};

export const CustomizeFooterProvider = (props: {
  children: React.ReactNode;
}) => {
  const [footerType, setFooterType] = useState<FooterType>(FOOTER_TYPE.NORMAL);
  const setType = useCallback((type: FooterType) => {
    setFooterType(type);
    return () => setFooterType(FOOTER_TYPE.NORMAL);
  }, []);
  return (
    <>
      <CustomizeFooterContext.Provider
        value={{
          type: footerType,
          setType,
        }}>
        {props.children}
      </CustomizeFooterContext.Provider>
    </>
  );
};
